import React from 'react'
import { HandCoins, Globe, ScrollText, BarChart3 } from 'lucide-react';

const features = [
  {
    icon: HandCoins,
    title: 'Get paid smarter, not harder',
    description: 'Accept payments via PayPal, Stripe, or bank transfer — and get instant alerts when clients open or pay your invoices.',
  },
  {
    icon: Globe,
    title: 'Built for every business',
    description: 'Supports multiple languages, currencies, and international billing formats — no borders, no limits.',
  },
  {
    icon: ScrollText,
    title: 'Designs that impress every time',
    description: 'Choose from over 150 professional, modern invoice templates crafted to make your brand stand out.',
  },
  {
    icon: BarChart3,
    title: 'See your success clearly',
    description: 'Get real-time insights and interactive charts that visualize your business growth at a glance.',
  },
];

const Features = () => {
  return (
    <section className="relative py-32 px-6 overflow-hidden">
      <div className="absolute inset-0 bg-gradient-to-b from-black/90 via-black/95 to-black/90" />

      <div className="absolute inset-0 opacity-20">
        <div className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 w-[800px] h-[800px] bg-[#1abc9c] rounded-full  blur-[150px]" />
      </div>

      <div className="relative z-10 max-w-7xl mx-auto">
        <div className="text-center mb-20">
          <h2 className="text-5xl md:text-5xl font-bold text-white mb-6">
            Powerful Features,
            <span className="gradient-text"> Simplified</span>
          </h2>
          <p className="text-xl text-white/60 max-w-2xl mx-auto">
            Everything you need to create, manage, and get paid — designed for speed, clarity, and confidence.
          </p>
        </div>

        <div className="grid md:grid-cols-2 lg:grid-cols-4 gap-6">
          {features.map((feature, index) => (
            <div
              key={index}
              className="group glass-card rounded-3xl p-8 transition-all duration-500 transform shadow-[0_20px_60px_rgba(26,188,156,0.3)] md:shadow-none md:hover:bg-white/10 md:hover:-translate-y-2 md:hover:shadow-[0_20px_60px_rgba(26,188,156,0.3)]"
              style={{ animationDelay: `${index * 100}ms` }}
            >
              <div className="w-14 h-14 rounded-2xl bg-gradient-to-br from-[#1abc9c] to-cyan-500 flex items-center justify-center mb-6 group-hover:scale-110 transition-transform duration-300">
                <feature.icon className="w-7 h-7 text-white" />
              </div>
              <h3 className="text-xl font-semibold text-white mb-3">
                {feature.title}
              </h3>
              <p className="text-white/60 leading-relaxed">
                {feature.description}
              </p>
            </div>
          ))}
        </div>
      </div>
    </section>
  )
}

export default Features